import { Circle, DeleteOutline, School } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Button, Card, CardContent, CircularProgress, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { doc, setDoc } from 'firebase/firestore';
import { deleteObject, ref } from 'firebase/storage';
import orderBy from "lodash.orderby";
import uniq from "lodash.uniq";
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getExperienceYears } from '../../common/utils';
import { UserEducation, UserExperience } from '../../consts/types/user';
import { db, storage } from '../../firebase';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import ItemMenu from '../Common/ItemMenu';
import AddEducationDialog from './Dialogs/AddEducationDialog';
import AddExperienceDialog from './Dialogs/AddExperienceDialog';
const { NotificationManager } = require('react-notifications');

interface ExperienceProps {

}

type Props = ExperienceProps;

const Experience: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const dispatch = useDispatch();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [isAddingExperience, setIsAddingExperience] = useState(false);
    const [experience, setExperience] = useState(user?.experience || []);
    const [isSavingExperience, setIsSavingExperience] = useState(false);
    const [isSavingEducation, setIsSavingEducation] = useState(false);
    const [isAddingEducation, setIsAddingEducation] = useState(false);
    const [education, setEducation] = useState(user?.education || []);

    useEffect(() => {
        setExperience(user?.experience || []);
    }, [user?.experience]);

    useEffect(() => {
        setEducation(user?.education || []);

    }, [user?.education]);


    const isShowAlert = () => {
        return (user?.education && user.education.length > 0 && user.education.some(edu => !edu.document)) ||
            (user?.experience && user.experience.length > 0 && user.experience.some(exp => !exp.document));
    }


    const removeExperience = (exp: UserExperience) => () => {
        if (user?.email) {
            const updatedExperience = experience.filter(e => e.companyName !== exp.companyName || e.fromYear !== exp.fromYear || e.toYear !== exp.toYear)
            setIsSavingExperience(true);
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, experience: updatedExperience } }));
            }
            const experienceYears = getExperienceYears(updatedExperience);
            setDoc(doc(db, "users", user.email), {
                experience: updatedExperience,
                experienceYears,
            }, { merge: true })
                .then((result) => {

                    setIsSavingExperience(false);
                    // NotificationManager.success('Changes were saved successfully!',);
                    if (exp.document) {
                        const storageRef = ref(storage, `${user.email}/${exp.companyName}__${exp.document}`);
                        // Delete the file
                        deleteObject(storageRef).catch((error) => { });
                    }
                })
                .catch(() => {
                    setIsSavingExperience(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    const removeEducation = (edu: UserEducation) => () => {
        if (user?.email) {
            const updatedEducation = education.filter(e => e.school !== edu.school || e.fromYear !== edu.fromYear || e.toYear !== edu.toYear || e.degree !== edu.degree)
            const updatedDegrees = uniq(updatedEducation.map(edu => edu.degree));
            setIsSavingEducation(true);
            if (user) {
                dispatch(userActionsCreators.setUser({ user: { ...user, education: updatedEducation } }));
            }
            setDoc(doc(db, "users", user.email), {
                education: updatedEducation,
                degrees: updatedDegrees,
            }, { merge: true })
                .then((result) => {
                    setIsSavingEducation(false);
                    // NotificationManager.success('Changes were saved successfully!',);
                    if (edu.document) {
                        const storageRef = ref(storage, `${user.email}/${edu.school}__${edu.document}`);
                        // Delete the file
                        deleteObject(storageRef).catch((error) => { });
                    }
                })
                .catch(() => {
                    setIsSavingEducation(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
    }

    return <Box display="flex" flexDirection="column" flex={1} gap={2}>
        {/* {isStepNotComplete(UserProfileStep.EducationAndExperience) && <Alert severity='warning' sx={{ display: { xs: "flex", md: "none" } }}>Step is not completed yet</Alert>} */}
        {/* {isShowAlert() && <Alert severity='warning' sx={{ mb: { xs: 2, md: 1 } }} >Verifying documents are missing. Please make sure to attach the relevant documents in order to gain a higher matching score.</Alert>} */}
        {/* <Typography fontSize="0.875rem" color="text.secondary">Education and work experience. For the current job/school, please leave the "To Year" field empty.</Typography> */}
        <Card variant='outlined'>
            <CardContent>
                <Box borderRadius="4px" sx={{ overflowY: "auto" }} >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Typography color="primary" fontWeight={500}>EDUCATION</Typography>
                            {isSavingEducation && <CircularProgress sx={{ width: "18px  !important", height: "18px !important", ml: 1 }} />}
                        </Box>
                        <Button variant="outlined" size="small" onClick={() => { setIsAddingEducation(true) }}>+ Add </Button>
                    </Box>

                    {/* <List> */}
                    {orderBy(education, [edu => "a" + edu.fromYear, edu => edu.toYear === -1 ? "current" : "a" + edu.toYear], ["desc", "desc"]).map((edu, index, arr) => <Card key={edu.school + index} sx={{ border: "none", }} variant="outlined" >
                        <CardContent sx={{ paddingX: 0, paddingBottom:"0 !important" }}>
                            <Box display="flex" alignItems="center" gap={2}>
                                <School />
                                <Box width="100%">
                                    <Box display="flex" justifyContent="space-between" alignItems="flex-end">
                                        <Typography color="text.primary" fontWeight={400} fontSize={{ xs: "1rem", md: "1.1rem" }} component="div">
                                            {edu.school}
                                        </Typography>
                                        <Box display="flex">
                                            <ItemMenu items={[{
                                                label: "Delete",
                                                icon: <DeleteOutline fontSize='small' color="inherit" />,
                                                onClick: removeEducation(edu)
                                            }]} />
                                        </Box>
                                    </Box>
                                    <Typography color="text.secondary" fontSize={{ xs: "0.9rem !important", md: "1rem !important" }} mt={0.5}>
                                        {`${edu.degree} `}
                                        {edu.grade > 0 && <Box display="inline" color="#999b9e" fontSize={{ xs: "0.45rem !important", md: "0.55rem !important" }}><Circle fontSize='inherit' color="inherit" /></Box>}
                                        {edu.grade > 0 && ` ${edu.grade}`}
                                    </Typography>
                                    <Typography color="text.secondary" mt={0.5} fontSize={{ xs: "0.9rem !important", md: "1rem !important" }} >
                                        {`${edu.fromYear} - ${edu.toYear === -1 ? "current" : edu.toYear}`}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* {edu.document && <Typography mt={1} color="text.secondary" fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                        {edu.document}
                    </Typography>}
                    <Typography mt={1} fontWeight={500} color={getFieldStatusColor(edu.status, true, edu.document)} fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                        {!edu.document ? UserStatus.NotVerified : edu.status}
                    </Typography> */}
                            {index < arr.length - 1  && <Divider  sx={{ mt: 2 }} />}
                        </CardContent>
                    </Card>)}
                    {/* </List> */}
                </Box>
            </CardContent>
        </Card>
        <Card variant='outlined' >
            <CardContent>
                <Box borderRadius="4px" sx={{ overflowY: "auto" }} >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box display="flex" alignItems="center">
                            <Typography color="primary" fontWeight={500}>EXPERIENCE</Typography>
                            {isSavingExperience && <CircularProgress sx={{ width: "18px  !important", height: "18px !important", ml: 1 }} />}
                        </Box>
                        <Button variant="outlined" size="small" onClick={() => { setIsAddingExperience(true) }}>+ Add </Button>
                    </Box>
                    {experience.length > 0 && <Card sx={{  border: "none" }} variant="outlined" >
                        <CardContent sx={{ paddingX: 0 }}>
                            <Timeline sx={{
                                padding: 0,
                                margin: 0,
                                [`& .${timelineItemClasses.root}:before`]: {
                                    flex: 0,
                                    padding: 0,
                                },
                            }}>
                                {orderBy(experience, [exp => "a" + exp.fromYear, exp => exp.toYear === -1 ? "current" : "a" + exp.toYear], ["desc", "desc"]).map((exp, index) => <TimelineItem key={exp.companyName + index}>
                                    <TimelineSeparator>
                                        <TimelineDot color="inherit" variant='outlined' />
                                        <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ paddingRight: 0 }}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" >
                                            <Typography fontSize={{ xs: "1rem", md: "1.1rem" }}>{exp.companyName}</Typography>
                                            <Box display="flex">
                                                <ItemMenu items={[{
                                                    label: "Delete",
                                                    icon: <DeleteOutline fontSize='small' color="inherit" />,
                                                    onClick: removeExperience(exp)
                                                }]} />
                                            </Box>
                                        </Box>
                                        <Typography fontSize={{ xs: "0.875rem", md: "1rem" }} color="GrayText" mb={0.5}>{exp.role}</Typography>
                                        <Typography fontSize={{ xs: "0.875rem", md: "1rem" }} color="GrayText">{`${exp.fromYear} - ${exp.toYear === -1 ? "current" : exp.toYear}`}</Typography>
                                        {/* {exp.document && <Typography fontSize={{ xs: "0.7rem", md: "0.875rem" }} color="GrayText">{exp.document}</Typography>}
                        <Typography mt={1} fontWeight={500} color={getFieldStatusColor(exp.status, true, exp.document)} fontSize={{ xs: "0.7rem", md: "0.875rem" }}>
                            {!exp.document ? UserStatus.NotVerified : exp.status}
                        </Typography> */}
                                    </TimelineContent>
                                </TimelineItem>
                                )}

                            </Timeline>
                        </CardContent>
                    </Card>}
                </Box>
            </CardContent>
        </Card>
        <AddEducationDialog isAddingEducation={isAddingEducation}
            isSavingEducation={isSavingEducation}
            setIsAddingEducation={setIsAddingEducation}
            setIsSavingEducation={setIsSavingEducation}
        />
        <AddExperienceDialog isAddingExperience={isAddingExperience}
            isSavingExperience={isSavingExperience}
            setIsAddingExperience={setIsAddingExperience}
            setIsSavingExperience={setIsSavingExperience}
        />
    </Box>;
}


export default Experience;

